import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const ReviewsSlider = () => {
  const swiperRef = useRef(null);
  const [playingIndex, setPlayingIndex] = useState(null);

  const handlePlayIconClick = (e, index) => {
    const container = e.currentTarget.closest(".video-container");
    const currentVideo = container.querySelector("video");

    const allVideos = document.querySelectorAll(".video-container video");

    allVideos.forEach((video, idx) => {
      if (video !== currentVideo) {
        video.pause();
        video.currentTime = 0;
        video.muted = true;
      }
    });

    if (currentVideo.paused) {
      currentVideo.muted = false;
      currentVideo.play();
      setPlayingIndex(index);
    } else {
      currentVideo.pause();
      setPlayingIndex(null);
    }
  };

  const handleVideoEnd = () => {
    setPlayingIndex(null);
  };

  const renderPlayPauseSVG = (isPlay = true) => {
    return isPlay ? (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="#fff">
        <path d="M8 5v14l11-7z" />
      </svg>
    ) : (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="#fff">
        <path d="M6 5h4v14H6zm8 0h4v14h-4z" />
      </svg>
    );
  };

  const videoData = [
    {
      src: "/assets/img/junk-removal-services-review.webm",
      text: "Bill from San Jose, and this is the 2nd time I hired junk Droid",
      name: "Robin",
      city: "San Jose, CA",
    },
    {
      src: "/assets/img/junk-removal-san-jose-review.webm",
      text: "We hired a junk Droid to remove some of the construction debris that we had at my parents' house",
      name: "Nick Cali",
      city: "Santa Clara, CA",
    },
  ];

  return (
    <div className="container junk-container">
      {/* Headings */}
      <div className="row driod-slider">
        <div className="col-md-12">
          <h6 className="desktop-customer-heading">
            Hear what our customers have to say!
          </h6>
          <h6 className="mobile-customer-heading">Customer Reviews</h6>
          <h2>
            Check out Junk Droid’s <br />
            top-rated reviews
          </h2>
          <div className="line-svg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={64}
              height={4}
              viewBox="0 0 64 4"
              fill="none"
            >
              <path
                d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                fill="#60BDFF"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* Arrows */}
      <div className="row">
        <div className="col-md-12">
          <div className="arrow-section arrow-section-desk">
            <button
              className="custom-prev"
              onClick={() => swiperRef.current.swiper.slidePrev()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-left"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                />
              </svg>
            </button>
            &nbsp;&nbsp;&nbsp;
            <button
              className="custom-next"
              onClick={() => swiperRef.current.swiper.slideNext()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-right"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Swiper Reviews */}
      <div className="reviews-slider">
        <Swiper
          ref={swiperRef}
          loop={true}
          spaceBetween={12}
          navigation={false}
          pagination={{ clickable: true }}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          breakpoints={{
            0: { slidesPerView: 1 },
            600: { slidesPerView: 2 },
            1000: { slidesPerView: 2 },
          }}
          modules={[Pagination, Autoplay]}
        >
          {videoData.map((item, idx) => (
            <SwiperSlide key={idx}>
              <div className="card top-review-card">
                <div className="video-container">
                  <video playsInline preload="auto" onEnded={handleVideoEnd}>
                    <source src={item.src} type="video/webm" />
                    Your browser does not support the video tag.
                  </video>
                  <div
                    className="play-icon"
                    onClick={(e) => handlePlayIconClick(e, idx)}
                  >
                    {renderPlayPauseSVG(playingIndex !== idx)}
                  </div>
                </div>
                <div className="card-body">
                  <img
                    src="/assets/img/quotes-v2-orange 1.svg"
                    className="quote-img"
                    loading="lazy"
                    alt="quote-img"
                  />
                  <blockquote className="blockquote mb-4">
                    <p className="mt-4 para-slider">{item.text}</p>
                  </blockquote>
                  <footer className="foot-slider rating-foot">
                    {item.name}
                  </footer>
                  <p className="city-title">{item.city}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Mobile Arrows */}
      <div className="row">
        <div className="col-md-12">
          <div className="arrow-section arrow-section-mobile">
            <button
              className="custom-prev"
              onClick={() => swiperRef.current.swiper.slidePrev()}
            />
            &nbsp;&nbsp;&nbsp;
            <button
              className="custom-next"
              onClick={() => swiperRef.current.swiper.slideNext()}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewsSlider;
